import PropTypes from 'prop-types';
import { Navbar, NavbarLink } from 'platfi-ui-components';
import Questionnaire from 'components/Questionnaire';
import FeatureFlag from 'modules/FeatureFlag';

import ConnectedNavNotifications from '../ConnectedNavNotification/ConnectedNavNotification';

export default function BusinessNavbar({
  apiKey,
  dark,
  logoUrl,
  navMenu,
  closeQuestionnaire,
  isQuestionnaireOpen,
  questionnaireOptions,
  entityId,
}) {
  const { type, reopenType } = questionnaireOptions;
  const options = reopenType === type || type === undefined ? questionnaireOptions : {};
  const openType = reopenType && type === undefined ? reopenType : type;

  return (
    <>
      <Questionnaire
        apiKey={apiKey}
        closeModal={closeQuestionnaire}
        isOpen={isQuestionnaireOpen}
        showMatches={false}
        type={openType}
        {...options}
      />
      <Navbar
        dark={dark}
        logoUrl={logoUrl}
        navNotification={<ConnectedNavNotifications />}
        navMenu={navMenu}
        mainLinks={
          <>
            <NavbarLink label="Dashboard" to="/funding" match={['/funding']} />
            <FeatureFlag flag="capitalReport">
              <NavbarLink
                label="Capital Report"
                to={`/capital-report/${entityId}`}
                match={[`/capital-report/${entityId}`]}
              />
            </FeatureFlag>
          </>
        }
      />
    </>
  );
}

BusinessNavbar.propTypes = {
  apiKey: PropTypes.string,
  dark: PropTypes.bool,
  navMenu: PropTypes.node,
  logoUrl: PropTypes.string,
  closeQuestionnaire: PropTypes.func.isRequired,
  isQuestionnaireOpen: PropTypes.bool,
  questionnaireOptions: PropTypes.object,
  entityId: PropTypes.number,
};
